import React from 'react';
import classNames from 'classnames';
// styles
import '../scss/_footer.scss';
// images
import connectMls from '../images/icons/connectBLC_background.png';
import { getSizes } from './utils';

class footer extends React.Component {
    render() {
        const { stacked, settings } = this.props;
        const { isMobile } = getSizes(768);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        return <div className={classNames('footer-container', {
            'stacked': stacked || isMobile,
            'grid': settings && settings.accessibilityNoticeUrl
        })}>
            <div>
                <img className="footer-logo" src={connectMls} alt="logo" />
                <span className="footer-tagline">Connecting Your Real Estate Community</span>
            </div>
            <div className="footer-links">
                <a href="https://clienthelp.dynaconnections.net" target="_blank" rel="noopener noreferrer">
                    Customer Support
                </a>
                {settings && settings.accessibilityNoticeUrl && 
                    <a href={settings.accessibilityNoticeUrl} target="_blank" rel="noopener noreferrer">
                        Accessibility Notice
                    </a>
                }
                <a href={process.env.REACT_APP_AgentURI + '/termsofservice.jsp'} target="_blank" rel="noopener noreferrer">
                    Terms of Service
                </a>
                <a href="https://clienthelp.dynaconnections.net/privacy-policy" target="_blank" rel="noopener noreferrer">
                    Privacy Policy</a>
            </div>
            <span className="footer-copyright"> ©dynaConnections 2001-{currentYear}</span>
        </div>
    }
}

export default footer;